import React from "react";
import { OreveButton } from "components/button/OreveButton.tsx";
import { ArrowBack } from "@mui/icons-material";
import { MainPageContentContainer } from "components/MainPageContentContainer";
import { Box, LinearProgress, Typography } from "@mui/material";
import Activation from "assets/svg/Type=Activer une carte RFID.svg";

interface RfidActivationLayoutProps {
    step: number;
    totalSteps: number;
    goBackToList: () => void;
    children: React.ReactNode;
}

export const RfidActivationLayout: React.FC<RfidActivationLayoutProps> = (
    {
        step,
        totalSteps,
        goBackToList,
        children
}) => {
    const progress = (step / totalSteps) * 100;

    return (
        <MainPageContentContainer
            sx={{
                position: "absolute",
                padding: 0,
                margin: 0,
                width: "calc(100vw - (1.5rem + 1rem))",
                height: "calc(100vh - (1.5rem + 132px + 2.5rem))",
            }}
        >
            <OreveButton
                sx={{
                    position: "absolute",
                    marginTop: "10px",
                    textDecoration: "none",
                    "&:hover, &:focus": {
                        backgroundColor: "transparent",
                        textDecoration: "none",
                    },
                }}
                variant="text"
                value="Retour à la liste de cartes"
                onClick={goBackToList}
                icon={ArrowBack}
            />

            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "flex-start", md: "center" },
                    justifyContent: { xs: "flex-start", md: "center" },
                    height: "100%",
                }}
            >
                {/* Zone gauche */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "2.25rem",
                        marginTop: { xs: "5rem", md: "10rem" },
                        width: { xs: "100%", md: "50vw" },
                        px: { xs: 2, sm: 4 },
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Typography variant="labelLarge" sx={{ mb: "10px" }}>
                            {step}/{totalSteps}
                        </Typography>
                        <LinearProgress
                            sx={{ width: "100px", borderRadius: "20px", bgcolor: "grey.100" }}
                            color="secondary"
                            variant="determinate"
                            value={progress}
                        />
                    </Box>

                    <Typography variant="h3" textAlign="center">
                        Activer une carte
                    </Typography>

                    {/* Contenu spécifique à l’étape */}
                    {children}
                </Box>

                {/* Zone droite */}
                <Box
                    sx={{
                        display: { xs: "none", md: "flex" },
                        bgcolor: "lightgrey.main",
                        borderBottomRightRadius: "20px",
                        borderTopRightRadius: "20px",
                        width: "70%",
                        height: "calc(100vh - (1.5rem + 132px + 2.5rem))",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        "& img": {
                            width: "100%",
                            height: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                            padding: "2rem",
                        },
                    }}
                >
                    <img src={Activation} alt="Activation RFID" />
                </Box>
            </Box>
        </MainPageContentContainer>
    );
};
